
import { Component, Vue, Prop } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { AppModule } from '@/store/modules/app'
import LogoUploader from '@/components/LogoUploader/index.vue'
@Component({
  name: 'productInfo',
  components: {
    LogoUploader
  }
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any
  private setForm: any = {}
  private lableList: any = {}

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private addItem(list: any[]) {
    list.push('')
  }
  private removeItem(list: any[], tag: string) {
    list.splice(list.indexOf(tag), 1)
  }

  private getLogo(logo: string) {
    this.setForm['qrcode_logo'] = logo
  }

  private getBkImg(logo: string) {
    this.setForm['top_bk_img'] = logo
  }

  private delImg(item: any) {
    if (item.field === 'top_bk_img') {
      this.setForm['top_bk_img'] = ''
    } else if (item.field === 'qrcode_logo') {
      this.setForm['qrcode_logo'] = ''
    }
  }

  private async update() {
    // 过滤配置信息
    const fields: string[] = this.lableList.map((item: any) => {
      return item.field
    })
    const newInfo = {}
    Object.keys(this.setForm)
      .filter((item: any) => {
        return fields.includes(item)
      })
      .forEach((field: string) => {
        newInfo[field] = this.setForm[field]
      })
    this.flag = true
    const data: any = {
      id: this.product.id,
      checkout_counter_param: { ...newInfo }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  private async init() {
    this.setForm = this.product.checkout_counter_param
      ? this.product.checkout_counter_param
      : {}
    await AppModule.GetConstant().then((res: any) => {
      this.lableList = res.PRODUCT_CHECKOUT_COUNTER_PARAM[this.product.code]
      if (this.lableList) {
        this.lableList.forEach((item: any) => {
          if (item.type === 'array') {
            this.$set(
              this.setForm,
              item.field,
              this.setForm[item.field] || ['']
            )
          } else {
            this.$set(this.setForm, item.field, this.setForm[item.field] || '')
          }
        })
      }
    })
  }
  mounted() {
    this.init()
  }
}
